<app-header></app-header>
<div id="patient_home_page">
  
  <section class="sec_banner">

    <figure class="banner_image">
    
      <div class="content-container-top">
        <div class="content_inner">
          <h3 class="top_text">Before an HAE attack begins</h3>
          <p>BRING</p>
          <p class="blur-text">FACTOR XIIa</p>
          <p>INTO FOCUS</p>
          <hr class="blur-text"/>
          <!--<img class="bring_hae_text_img mobilehidden" src="assets/img/bring_hae_content_img.png" />
          <img class="bring_hae_text_img desktophidden" src="assets/img/bring_hae_content_img_mobile.png" />-->
          <p class="middle_text">Are you thinking about your future with HAE? <br>Discover the unique role of <span>Factor XIIa.</span></p>
          <!--<p class="bottom_text">Explore the role of Factor XIIa</p>-->
          <img class="down_arrow_img" src="assets/img/down_arrow_icon.svg" title="Down arrow" alt="Down arrow" />
        </div>
      </div>
    </figure>
  </section>
  <section class="sec_pathway">
    <div class="content-container">
      <div class="pathway_row pure-g">
        <div class="pathway_column_left pure-u-1 pure-u-lg-13-24 pure-u-md-10-24">
          <h2 class="pathway_heading">Factor XIIa initiates the HAE pathway that leads to attacks in someone with HAE</h2>
          <p class="pathway_sub_head">Factor XIIa (pronounced “Factor 12-a”) is a protein that occurs naturally in your body. In hereditary angioedema (HAE), it initiates the HAE pathway.</p>
          <div class="borderhr"></div>
          <h3>If the HAE pathway is not regulated, it leads to an attack</h3>
          <!--<p class="pathway_sub_head">No treatment today targets Factor XIIa</p>-->
          <div class="mobile_pathway_img desktophidden">
            <!--<img class="mobilehidden" [src]="image_src" />-->
            <p *ngIf="this.showList">Factor XIIa is at the top of the <br>HAE pathway</p>
            <img class="desktophidden img-pathway" src="{{ showVar ? 'assets/img/expand_pathway_mobile.png' : 'assets/img/collapse_pathway_mobile.png'}}" alt="Graphic: The pathway that leads to an HAE attack—how it all gets started"/>
          </div>
          <div class="button_sec"><button class="pathway_btn" (click)="toggleImage()">{{ showVar ? 'COLLAPSE THE PATHWAY' : 'EXPAND THE PATHWAY'}}<span>{{ showVar ? '-' : '+'}}</span> </button></div>
          <h3 class="second_head">No treatment today targets Factor XIIa</h3>
          <p class="pathway_sub_head">Not one of the treatments available today targets Factor XIIa―the top of the HAE pathway.</p>
          <ul class="pathway_sub_head" *ngIf="this.showList">
            <li>Current long-term prophylactic treatments either bring C1-INH levels closer to normal or inhibit kallikrein</li>
          </ul>
        </div>
        <div class="pure-u-1 pure-u-lg-2-24 pure-u-md-2-24"></div>
        <div class="pathway_column_right pure-u-1 pure-u-lg-9-24 pure-u-md-12-24 mobilehidden">
          <p class="mobilehidden" *ngIf="this.showList">Factor XIIa is at the top of the <br>HAE pathway</p>
          <img class="mobilehidden img-pathway" [src]="image_src" alt="Graphic: The pathway that leads to an HAE attack—how it all gets started" />
          <!--<img class="desktophidden" src="{{ showVar ? 'assets/img/factor_XII_expand_mobile.jpg' : 'assets/img/factor_XII_collapse_mobile.jpg'}}" />-->

          
        </div>
      </div>
      <h1 id="doctor-discussion-guide"><b>Factor XIIa</b> plays a critical role in the HAE pathway</h1>
    </div>
  </section>
  <section class="sec_download_guide">
    <div class="content-container">
      <div class="guide_row">
        <div class="guide_img ">
          <img src="assets/img/talk_to_doc_img.png" alt="Doctor Discussion Guide download icon" title="Doctor Discussion Guide download icon"/>
        </div>
        <div class="guide_content ">
          <h3>Talk to your doctor about your HAE</h3>
          <p>This guide can help you discuss your experience with HAE and the pathway that leads to attacks.</p>
          <a download href="../assets/pdf/FXIIa_Patient_Doctor_Discussion_Guide.pdf" title="Doctor Discussion Guide"><p>DOWNLOAD THE GUIDE</p> <img src="assets/img/download_icon.svg" alt="Download the Guide icon" title="Download the Guide icon"/></a>
        </div>
      </div>
    </div>


  </section>
<app-signup (submitSuccess)="OnThankyouShow()"></app-signup>
</div>
<app-footer></app-footer>
